<template>
  <div v-if='isLoading'>
    <wc-loading line></wc-loading>
  </div>
  <div v-else>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='Accounting Stats'
            titleIcon='mdi-finance'
            titleIconColor='success'
          >
            <v-data-table
              :items='stats'
              :headers='headers'
              :items-per-page='-1'
              hide-default-footer
              dense
              no-data-text='Please use search at top right, this summary table has been disabled for now.'
            >
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import accountingAPI from '@/api/accounting';

export default {
  name: 'accounting-dashboard',
  data: () => ({
    isLoading: false,
    stats: [],
    headers: [
      { text: 'Division', value: 'name' },
      { text: '# Unsent', value: 'unsent_count', align: 'center', width: '120' },
      { text: '$ Unsent', value: 'unsent_total.amount_os__sum', align: 'center', width: '120' },
      { text: '# Unpaid', value: 'unpaid_count', align: 'center', width: '120' },
      { text: '$ Unpaid', value: 'unpaid_total.amount_os__sum', align: 'center', width: '120' },
      { text: '# Overdue', value: 'overdue_count', align: 'center', width: '120' },
      { text: '$ Overdue', value: 'overdue_total.amount_os__sum', align: 'center', width: '120' }
    ]
  }),
  created () {
    this.getData();
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.stats = await accountingAPI.getAccountingDashboard()
      this.isLoading = false
    }
  },
  components: {
   
  }
}
</script>
